import { useEffect, useState } from 'react';
import { LocalTrackPublication, Participant, RemoteTrackPublication } from 'twilio-video';
import { ParticipantEvents } from 'screens/TelehealthScreen/utils/enums';

type TrackPublication = LocalTrackPublication | RemoteTrackPublication;

export default function usePublications(participant: Participant | null) {
  const [publications, setPublications] = useState<TrackPublication[]>([]);

  useEffect(() => {
    const publicationAdded = (publication: TrackPublication) =>
      setPublications((prevPublications) => [...prevPublications, publication]);
    const publicationRemoved = (publication: TrackPublication) =>
      setPublications((prevPublications) =>
        prevPublications.filter((trackPublication) => trackPublication !== publication),
      );

    if (participant) {
      // Reset the publications when the 'participant' variable changes.
      setPublications(Array.from(participant.tracks.values()) as TrackPublication[]);

      participant.on(ParticipantEvents.TrackPublished, publicationAdded);
      participant.on(ParticipantEvents.TrackUnpublished, publicationRemoved);
    }

    return () => {
      if (participant) {
        participant.off(ParticipantEvents.TrackPublished, publicationAdded);
        participant.off(ParticipantEvents.TrackUnpublished, publicationRemoved);
      }
    };
  }, [participant]);

  return publications;
}
